import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n";
import { App } from "./App";
import { initLiff } from "./lib/liff";
import { initSentry } from "./lib/sentry";

initSentry();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

initLiff().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
